import { useState, useEffect } from 'react';
import { AxiosError } from 'axios';
import { getSubscriptionStatus } from '@/services/subscriptionApi';

/**
 * 主动检查用户订阅状态。
 * 页面加载时调用 /subscription/status/，若未订阅或已过期则显示弹窗。
 * 与后端 402 拦截形成双重保护。
 */
export function useSubscriptionGuard() {
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getSubscriptionStatus()
      .then((status) => {
        if (cancelled) return;
        if (!status?.isValid) {
          setShowDialog(true);
        }
      })
      .catch((error: AxiosError) => {
        if (cancelled) return;
        // 仅在后端明确返回 402 (SUBSCRIPTION_REQUIRED) 时弹出无订阅提示。
        // 对于网络错误、服务器 5xx 等暂态故障，保持静默——后端中间件
        // 会对实际 FSOP API 调用独立执行订阅校验。
        if (error.response?.status === 402) {
          setShowDialog(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { showDialog, setShowDialog };
}
